import styled from "styled-components";
import { Link } from 'react-router-dom';



export const Container = styled.div`
    width: ${({width}) => width};
    height: ${({height}) => height};
    position: relative;
    border: 1px solid rgba(0,0,0,0.2);
    padding: 2px;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
    transition: all .5s;
    display: flex;

    &:hover{
        filter: brightness(85%);
    }
`

export const CoverAppLink = styled(Link)`
    display: flex;
    width: 100%;
    height: 100%;
    text-decoration: none;
    border-radius: 4px;
    overflow: hidden;
`

export const CoverAppImageContainer = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    text-decoration: none;
    border-radius: 4px;
    overflow: hidden;
`

export const CoverImage = styled.img`
    width: 100%;
    height: 100%;
`

export const CoverImageText = styled.span`
    position: absolute;
    left: 0;
    top: 0;
    padding: 8px;
    color: ${({$color}) => $color};
    font-size: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    max-height: 80%;
`
